/**
 * useAnchor hook.
 */
import DefaultAnchor from '@components/elements/anchor/ui/defaultAnchor';
import EpgAnchor from '@components/elements/anchor/ui/epgAnchor';
import Rail from '@shared/classes/rail';
import { RailDisplayMode } from '@shared/types/enums/rail';

/**
 * Hook for the anchor component. Based on the rail display mode, it returns the appropriate anchor component.
 */
export default function useAnchor(rail: Rail) {
  let Anchor = null;
  switch (rail.displayMode) {
    case RailDisplayMode.CHANNEL_GUIDE_PHOTO:
    case RailDisplayMode.PHOTO:
      Anchor = DefaultAnchor;
      break;
    case RailDisplayMode.EPG:
      Anchor = EpgAnchor;
      break;
  }
  return { Anchor };
}
